window.addEventListener('load', () => {
    let targetElements = document.querySelectorAll('.animate-decoration');

    if (targetElements.length) {
        for ( let targetElement of targetElements ) {
            startListening();
            processScroll(); // If element in viewport, show on page load

            function startListening() {
                window.addEventListener('scroll', processScroll);
            }

            function stopListening() {
                window.removeEventListener('scroll', processScroll);
            }

            let scrollTimer, lastScrollFireTime = 0;

            function processScroll() {
                let minScrollTime = 150;
                let now = new Date().getTime();

                if (!scrollTimer) {
                    if (now - lastScrollFireTime > (minScrollTime)) {
                        checkViewport();
                        lastScrollFireTime = now;
                    }
                    scrollTimer = setTimeout(function() {
                        checkViewport();
                        scrollTimer = null;
                        lastScrollFireTime = new Date().getTime();
                    }, minScrollTime);
                }
            }

            const isElementXPercentInViewport = function(el, percentVisible) {
                let rect = el.getBoundingClientRect(),
                    windowHeight = (window.innerHeight || document.documentElement.clientHeight);

                return !(
                    Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
                    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
                )
            };

            function checkViewport() {
                if (isElementXPercentInViewport(targetElement, 40)) {
                    targetElement.classList.remove('!inset-0');
                    targetElement.classList.remove('!opacity-0');
                    stopListening();
                }
            }
        }
    }
});
